import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-2310">
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-2311">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-2312" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-2313" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-2314">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-2315">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-2316" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-2317" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-2318" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-2319">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-2320">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-2321" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-2322" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-2323">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-2324">
            <thead data-id="element-2325">
              <tr data-id="element-2326">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-2327">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-2328" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2329">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-2330">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-2331">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-2332" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-2333">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-2334" />
          <div className="flex gap-2" data-id="element-2335">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-2336" />)}
          </div>
        </div>
      </div>
    </div>;
}